const RAZORPAY_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let loadPromise = null;

// Injects the Razorpay Checkout script once and caches the in-flight promise.
export const loadRazorpay = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = RAZORPAY_SRC;
    script.onload = () => resolve(true);
    script.onerror = () => {
      loadPromise = null;
      resolve(false);
    };
    document.body.appendChild(script);
  });

  return loadPromise;
};
